import { render, staticRenderFns } from "./GQS-datapoints-details-modal.vue?vue&type=template&id=2e1144e6"
import script from "./GQS-datapoints-details-modal.vue?vue&type=script&lang=js"
export * from "./GQS-datapoints-details-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports